import { render } from "./PatientGoals.vue?vue&type=template&id=05e4f224&ts=true"
import script from "./PatientGoals.ts?vue&type=script&lang=ts&external"
export * from "./PatientGoals.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__